import actions from "@components/Redux/Global/actions";
import { useRouter } from "next/router";
import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

const useBreadcrumbsInit = () => {
    const {breadcrumbs} = useSelector((state) => state.globalReducer);
    const [init, setInit] = useState(false);
    const [localBreadcrumbs, setLocalBreadcrumbs] = useState(breadcrumbs)
    const router = useRouter();
    const dispatch = useDispatch();
    const isFirstRender = useRef(true);

    useEffect(() => {
        if (init) {
            isFirstRender.current = false;
        }
    }, [init]);

    useEffect(() => {
		if(!isFirstRender.current){
            const {links, last} = localBreadcrumbs;
            if(last == breadcrumbs?.last) return;
            const payload = !links && !last ? [] : {
                links,
                last
            }
            dispatch({
                type: actions.SET_BREADCRUMBS,
                payload: payload
            })
        }
	}, [router.asPath, localBreadcrumbs])

    const initBreadcrumbs = () => {
        setInit(true);
    };

    return {
        initBreadcrumbs,
        setLocalBreadcrumbs,
    };
};

export default useBreadcrumbsInit;